import { vm } from '@/main';
import { i18n } from '@/localization';
import {ProjectBudgetViewModel} from '@/services/api/nswag/stapiclient_generated';

export function notifyError(messageTranslationKey: string) {
  vm.$notify({
    text: i18n.t(messageTranslationKey).toString(),
    data: {
      icon: 'fa-exclamation-triangle',
      class: 'bg-red-600 text-fifteen text-white',
    },
  });
}

export function notifyWarning(messageTranslationKey: string) {
  vm.$notify({
    text: i18n.t(messageTranslationKey).toString(),
    data: {
      icon: 'fa-exclamation-triangle',
      class: 'bg-yellow-600 text-fifteen text-white',
    },
  });
}

export function notifyDeletion(undoFunction: Function) {
  vm.$notify({
    text: i18n.t('Erfolgreich gelöscht').toString(),
    duration: 6000,
    data: {
      icon: 'fa-trash',
      class: 'bg-green-600 text-fifteen text-white',
      isDeletion: true,
      undoFunc: undoFunction,
    },
  });
}

export function notifySuccess(messageTranslationKey: string) {
  vm.$notify({
    text: i18n.t(messageTranslationKey).toString(),
    data: {
      icon: 'fa-check',
      class: 'bg-green-600 text-fifteen text-white',
    },
  });
}

export function notifyBudget(model: ProjectBudgetViewModel) {
  vm.$notify({
    text: '',
    duration: 4500,
    data: {
      isBudget: true,
      budget: model,
      class: 'bg-white'
    },
  });
}
